export function getTxUrl(
    item: { chainId: string },
    tx: string,
    chainType: string,
    networkType: string
  ) { 
    if (chainType === "sui") {
      return `https://suiscan.xyz/${networkType}/tx/${tx}`;
    }

    switch (String(item.chainId)) {
      case "137":
        return `https://polygonscan.com/tx/${tx}`;
      case "88888":
        return `https://chiliscan.com/tx/${tx}`;
      case "43114":
        return `https://subnets.avax.network/c-chain/tx/${tx}`;
      case "80002":
        return `https://amoy.polygonscan.com/tx/${tx}`;
      case "88882":
        return `https://testnet.chiliscan.com/tx/${tx}`;
      case "43113":
        return `https://subnets-test.avax.network/c-chain/block/${tx}`;
      default:
        return null;
    }
  }